import React from 'react';

import distanceMeasureIcon from 'assets/distance-measure.svg';

const SidebarDistanceMeasureIcon = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}): JSX.Element => (
  <img
    src={distanceMeasureIcon}
    alt="distance-icon"
    className={className}
    onClick={() => onClick()}
  />
);

export default SidebarDistanceMeasureIcon;
